import { Icon } from "@/components/Icon";
import SubLayout from "@/components/SubLayout";
import { Form, ImageUploader, Input } from "antd-mobile";
import { useEffect } from "react";
import { AvatarSelect } from "./components/AvatarSelect";
import styles from "./index.module.scss";
import { useLogic } from "./logic";

export function PageNickname() {
  const logic = useLogic();
  useEffect(() => {
    logic.fetchUserInfo().then(() => {
      logic.form.setFieldsValue({
        nickname: logic.userInfo.nickname,
        avatar: logic.userInfo.avatar,
      });
    });
  }, []);
  return (
    <SubLayout
      title={"个人信息"}
      header={{
        extra: (
          <div onClick={logic.saveData} style={{ cursor: "pointer" }}>
            存储
          </div>
        ),
      }}
    >
      <section className={styles.content}>
        <Form form={logic.form} className={styles.form}>
          <Form.Item name="nickname" label="昵称">
            <Input placeholder="最长可输入12位字符" />
          </Form.Item>
          <Form.Item name="avatar" label="头像">
            <AvatarSelect />
          </Form.Item>

          {/* <Form.Item name="avatar_file" label="">
            <ImageUploader
              upload={logic.onUpload}
              className={styles.camera}
              multiple={false}
              columns={0}
              renderItem={() => null}
              preview={false}
            >
              <div className={styles.camera_content}>
                <Icon name={"camera"} size={"50px"} />
              </div>
            </ImageUploader>
          </Form.Item> */}
          
        </Form>
      </section>
    </SubLayout>
  );
}

export default PageNickname;
